//
//
//
//

import wcs from '@/scripts/libs/wcs'
import { WcsLocales } from '@/scripts/libs/wcs/types/locales'

const { locale, currency } = wcs.getStoreConfig()

export default {
  name: 'format-price',
  props: {
    value: {
      type: Number,
    },
  },
  computed: {
    formatedPrice() {
      const localeModified = locale === WcsLocales.FR_CA ? WcsLocales.EN_CA : locale

      try {
        return new Intl.NumberFormat(localeModified, { style: 'currency', currency }).format(
          Number(this.value)
        )
      } catch (e) {
        return this.value
      }
    },
  },
}
